// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Corporate Theme Variables */
:root {
  /* Primary Colors - Professional Blue Gradient */
  --primary-color: #1a365d;
  --primary-light: #2c5282;
  --primary-dark: #1a202c;
  --primary-accent: #3182ce;
  
  /* Secondary Colors - Professional Gray Scale */
  --secondary-color: #4a5568;
  --secondary-light: #718096;
  --secondary-dark: #2d3748;
  
  /* Success & Status Colors */
  --success-color: #38a169;
  --success-light: #68d391;
  --warning-color: #ed8936;
  --warning-light: #fbb05a;
  --error-color: #e53e3e;
  --error-light: #fc8181;
  
  /* WhatsApp Brand Colors (for specific elements) */
  --whatsapp-green: #25d366;
  --whatsapp-green-dark: #128c7e;
  
  /* Neutral Colors */
  --white: #ffffff;
  --gray-50: #f7fafc;
  --gray-100: #edf2f7;
  --gray-200: #e2e8f0;
  --gray-300: #cbd5e0;
  --gray-400: #a0aec0;
  --gray-500: #718096;
  --gray-600: #4a5568;
  --gray-700: #2d3748;
  --gray-800: #1a202c;
  --gray-900: #171923;
  
  /* Spacing */
  --space-xs: 0.25rem;
  --space-sm: 0.5rem;
  --space-md: 1rem;
  --space-lg: 1.5rem;
  --space-xl: 2rem;
  --space-2xl: 3rem;
  --space-3xl: 4rem;
  
  /* Typography */
  --font-family-base: 'Inter', 'Segoe UI', 'Roboto', sans-serif;
  --font-family-heading: 'Inter', 'Segoe UI', 'Roboto', sans-serif;
  
  --font-size-xs: 0.75rem;
  --font-size-sm: 0.875rem;
  --font-size-base: 1rem;
  --font-size-lg: 1.125rem;
  --font-size-xl: 1.25rem;
  --font-size-2xl: 1.5rem;
  --font-size-3xl: 1.875rem;
  --font-size-4xl: 2.25rem;
  
  --font-weight-normal: 400;
  --font-weight-medium: 500;
  --font-weight-semibold: 600;
  --font-weight-bold: 700;
  
  --line-height-tight: 1.25;
  --line-height-snug: 1.375;
  --line-height-normal: 1.5;
  --line-height-relaxed: 1.625;
  
  /* Border Radius */
  --radius-sm: 0.375rem;
  --radius-md: 0.5rem;
  --radius-lg: 0.75rem;
  --radius-xl: 1rem;
  --radius-2xl: 1.5rem;
  
  /* Shadows */
  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  --shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  --shadow-2xl: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  
  /* Transitions */
  --transition-fast: 150ms ease-in-out;
  --transition-base: 200ms ease-in-out;
  --transition-slow: 300ms ease-in-out;
  
  /* Z-index */
  --z-dropdown: 1000;
  --z-sticky: 1020;
  --z-fixed: 1030;
  --z-modal-backdrop: 1040;
  --z-modal: 1050;
  --z-popover: 1060;
  --z-tooltip: 1070;
}

/* Base Typography */
body {
  font-family: var(--font-family-base);
  font-size: var(--font-size-base);
  line-height: var(--line-height-normal);
  color: var(--gray-700);
  background-color: var(--gray-50);
}

h1, h2, h3, h4, h5, h6 {
  font-family: var(--font-family-heading);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-tight);
  color: var(--primary-color);
  margin: 0;
}

h1 { font-size: var(--font-size-3xl); }
h2 { font-size: var(--font-size-2xl); }
h3 { font-size: var(--font-size-xl); }
h4 { font-size: var(--font-size-lg); }
h5 { font-size: var(--font-size-base); }
h6 { font-size: var(--font-size-sm); }

/* Button Base Styles */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-sm);
  padding: var(--space-sm) var(--space-lg);
  font-family: var(--font-family-base);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-tight);
  border: 1px solid transparent;
  border-radius: var(--radius-md);
  cursor: pointer;
  transition: all var(--transition-fast);
  text-decoration: none;
  white-space: nowrap;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Button Variants */
.btn-primary {
  background-color: var(--primary-color);
  color: var(--white);
  border-color: var(--primary-color);
}

.btn-primary:hover:not(:disabled) {
  background-color: var(--primary-light);
  border-color: var(--primary-light);
  transform: translateY(-1px);
  box-shadow: var(--shadow-lg);
}

.btn-secondary {
  background-color: var(--white);
  color: var(--secondary-color);
  border-color: var(--gray-300);
}

.btn-secondary:hover:not(:disabled) {
  background-color: var(--gray-50);
  border-color: var(--gray-400);
}

.btn-success {
  background-color: var(--success-color);
  color: var(--white);
  border-color: var(--success-color);
}

.btn-success:hover:not(:disabled) {
  background-color: var(--success-light);
  transform: translateY(-1px);
  box-shadow: var(--shadow-lg);
}

.btn-warning {
  background-color: var(--warning-color);
  color: var(--white);
  border-color: var(--warning-color);
}

.btn-warning:hover:not(:disabled) {
  background-color: var(--warning-light);
  transform: translateY(-1px);
}

.btn-danger {
  background-color: var(--error-color);
  color: var(--white);
  border-color: var(--error-color);
}

.btn-danger:hover:not(:disabled) {
  background-color: var(--error-light);
  transform: translateY(-1px);
}

/* Button Sizes */
.btn-sm {
  padding: calc(var(--space-sm) * 0.75) var(--space-md);
  font-size: var(--font-size-xs);
}

.btn-lg {
  padding: var(--space-md) var(--space-xl);
  font-size: var(--font-size-base);
}

/* Card Components */
.card {
  background-color: var(--white);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--gray-200);
  transition: all var(--transition-base);
}

.card:hover {
  box-shadow: var(--shadow-md);
  transform: translateY(-2px);
}

.card-header {
  padding: var(--space-lg) var(--space-xl);
  border-bottom: 1px solid var(--gray-200);
}

.card-body {
  padding: var(--space-xl);
}

.card-footer {
  padding: var(--space-lg) var(--space-xl);
  border-top: 1px solid var(--gray-200);
  background-color: var(--gray-50);
  border-radius: 0 0 var(--radius-lg) var(--radius-lg);
}

/* Form Elements */
.form-group {
  margin-bottom: var(--space-lg);
}

.form-label {
  display: block;
  margin-bottom: var(--space-sm);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  color: var(--gray-700);
}

.form-input {
  width: 100%;
  padding: var(--space-md);
  font-size: var(--font-size-sm);
  line-height: var(--line-height-tight);
  color: var(--gray-700);
  background-color: var(--white);
  border: 1px solid var(--gray-300);
  border-radius: var(--radius-md);
  transition: border-color var(--transition-fast), box-shadow var(--transition-fast);
}

.form-input:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.form-select {
  width: 100%;
  padding: var(--space-md);
  font-size: var(--font-size-sm);
  color: var(--gray-700);
  background-color: var(--white);
  border: 1px solid var(--gray-300);
  border-radius: var(--radius-md);
  transition: border-color var(--transition-fast);
}

/* Modal Base */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: var(--z-modal);
  padding: var(--space-lg);
}

.modal-content {
  background-color: var(--white);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-2xl);
  max-width: 90vw;
  max-height: 90vh;
  overflow: hidden;
  animation: modalSlideIn 0.3s ease-out;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-50px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.modal-header {
  padding: var(--space-xl);
  border-bottom: 1px solid var(--gray-200);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.modal-title {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  color: var(--primary-color);
}

.modal-close {
  background: none;
  border: none;
  font-size: var(--font-size-xl);
  color: var(--gray-400);
  cursor: pointer;
  padding: var(--space-sm);
  border-radius: var(--radius-md);
  transition: color var(--transition-fast);
}

.modal-close:hover {
  color: var(--gray-600);
}

.modal-body {
  padding: var(--space-xl);
  overflow-y: auto;
}

.modal-footer {
  padding: var(--space-xl);
  border-top: 1px solid var(--gray-200);
  display: flex;
  gap: var(--space-md);
  justify-content: flex-end;
}

/* Status Badges */
.status-badge {
  display: inline-flex;
  align-items: center;
  padding: var(--space-xs) var(--space-sm);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-medium);
  border-radius: var(--radius-md);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.status-badge.success {
  background-color: rgba(56, 161, 105, 0.1);
  color: var(--success-color);
}

.status-badge.warning {
  background-color: rgba(237, 137, 54, 0.1);
  color: var(--warning-color);
}

.status-badge.danger {
  background-color: rgba(229, 62, 62, 0.1);
  color: var(--error-color);
}

.status-badge.info {
  background-color: rgba(49, 130, 206, 0.1);
  color: var(--primary-accent);
}

/* Loading States */
.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid var(--gray-200);
  border-top: 4px solid var(--primary-color);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-text {
  text-align: center;
  color: var(--gray-500);
  margin-top: var(--space-md);
}

/* Responsive Utilities */
@media (max-width: 768px) {
  .modal-content {
    margin: var(--space-md);
    max-width: calc(100vw - 2rem);
  }
  
  .modal-header,
  .modal-body,
  .modal-footer {
    padding: var(--space-lg);
  }
  
  .btn {
    padding: var(--space-md) var(--space-lg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/corporate-theme.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;EACE,gDAAgD;EAChD,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,yBAAyB;;EAEzB,+CAA+C;EAC/C,0BAA0B;EAC1B,0BAA0B;EAC1B,yBAAyB;;EAEzB,4BAA4B;EAC5B,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,sBAAsB;EACtB,sBAAsB;;EAEtB,kDAAkD;EAClD,yBAAyB;EACzB,8BAA8B;;EAE9B,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;;EAEnB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;;EAEjB,eAAe;EACf,6DAA6D;EAC7D,gEAAgE;;EAEhE,uBAAuB;EACvB,wBAAwB;EACxB,sBAAsB;EACtB,wBAAwB;EACxB,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;;EAExB,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;;EAEvB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,4BAA4B;;EAE5B,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;;EAEpB,YAAY;EACZ,4CAA4C;EAC5C,kFAAkF;EAClF,oFAAoF;EACpF,sFAAsF;EACtF,mDAAmD;;EAEnD,gBAAgB;EAChB,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;;EAEpC,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,oCAAoC;EACpC,gCAAgC;EAChC,sCAAsC;EACtC,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,uCAAuC;EACvC,wCAAwC;EACxC,qCAAqC;EACrC,2BAA2B;EAC3B,SAAS;AACX;;AAEA,KAAK,+BAA+B,EAAE;AACtC,KAAK,+BAA+B,EAAE;AACtC,KAAK,8BAA8B,EAAE;AACrC,KAAK,8BAA8B,EAAE;AACrC,KAAK,gCAAgC,EAAE;AACvC,KAAK,8BAA8B,EAAE;;AAErC,uBAAuB;AACvB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,wCAAwC;EACxC,oCAAoC;EACpC,8BAA8B;EAC9B,sCAAsC;EACtC,qCAAqC;EACrC,6BAA6B;EAC7B,+BAA+B;EAC/B,eAAe;EACf,sCAAsC;EACtC,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,sCAAsC;EACtC,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;EAClC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA,iBAAiB;AACjB;EACE,qDAAqD;EACrD,8BAA8B;AAChC;;AAEA;EACE,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA,oBAAoB;AACpB;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,4BAA4B;EAC5B,iCAAiC;EACjC,sCAAsC;AACxC;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,wCAAwC;EACxC,wCAAwC;AAC1C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wCAAwC;EACxC,qCAAqC;EACrC,gCAAgC;EAChC,oDAAoD;AACtD;;AAEA,kBAAkB;AAClB;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,8BAA8B;EAC9B,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,8BAA8B;EAC9B,qCAAqC;EACrC,sBAAsB;EACtB,8BAA8B;EAC9B,iCAAiC;EACjC,+BAA+B;EAC/B,kFAAkF;AACpF;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,8BAA8B;EAC9B,sBAAsB;EACtB,8BAA8B;EAC9B,iCAAiC;EACjC,+BAA+B;EAC/B,+CAA+C;AACjD;;AAEA,eAAe;AACf;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,wBAAwB;EACxB,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,8BAA8B;EAC9B,sBAAsB;EACtB,eAAe;EACf,wBAAwB;EACxB,+BAA+B;EAC/B,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,qCAAqC;EACrC,aAAa;EACb,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,wCAAwC;EACxC,8BAA8B;EAC9B,sCAAsC;EACtC,+BAA+B;EAC/B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,4BAA4B;AAC9B;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,0CAA0C;EAC1C,kBAAkB;EAClB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA,yBAAyB;AACzB;EACE;IACE,uBAAuB;IACvB,6BAA6B;EAC/B;;EAEA;;;IAGE,wBAAwB;EAC1B;;EAEA;IACE,wCAAwC;EAC1C;AACF","sourcesContent":["/* Corporate Theme Variables */\n:root {\n  /* Primary Colors - Professional Blue Gradient */\n  --primary-color: #1a365d;\n  --primary-light: #2c5282;\n  --primary-dark: #1a202c;\n  --primary-accent: #3182ce;\n  \n  /* Secondary Colors - Professional Gray Scale */\n  --secondary-color: #4a5568;\n  --secondary-light: #718096;\n  --secondary-dark: #2d3748;\n  \n  /* Success & Status Colors */\n  --success-color: #38a169;\n  --success-light: #68d391;\n  --warning-color: #ed8936;\n  --warning-light: #fbb05a;\n  --error-color: #e53e3e;\n  --error-light: #fc8181;\n  \n  /* WhatsApp Brand Colors (for specific elements) */\n  --whatsapp-green: #25d366;\n  --whatsapp-green-dark: #128c7e;\n  \n  /* Neutral Colors */\n  --white: #ffffff;\n  --gray-50: #f7fafc;\n  --gray-100: #edf2f7;\n  --gray-200: #e2e8f0;\n  --gray-300: #cbd5e0;\n  --gray-400: #a0aec0;\n  --gray-500: #718096;\n  --gray-600: #4a5568;\n  --gray-700: #2d3748;\n  --gray-800: #1a202c;\n  --gray-900: #171923;\n  \n  /* Spacing */\n  --space-xs: 0.25rem;\n  --space-sm: 0.5rem;\n  --space-md: 1rem;\n  --space-lg: 1.5rem;\n  --space-xl: 2rem;\n  --space-2xl: 3rem;\n  --space-3xl: 4rem;\n  \n  /* Typography */\n  --font-family-base: 'Inter', 'Segoe UI', 'Roboto', sans-serif;\n  --font-family-heading: 'Inter', 'Segoe UI', 'Roboto', sans-serif;\n  \n  --font-size-xs: 0.75rem;\n  --font-size-sm: 0.875rem;\n  --font-size-base: 1rem;\n  --font-size-lg: 1.125rem;\n  --font-size-xl: 1.25rem;\n  --font-size-2xl: 1.5rem;\n  --font-size-3xl: 1.875rem;\n  --font-size-4xl: 2.25rem;\n  \n  --font-weight-normal: 400;\n  --font-weight-medium: 500;\n  --font-weight-semibold: 600;\n  --font-weight-bold: 700;\n  \n  --line-height-tight: 1.25;\n  --line-height-snug: 1.375;\n  --line-height-normal: 1.5;\n  --line-height-relaxed: 1.625;\n  \n  /* Border Radius */\n  --radius-sm: 0.375rem;\n  --radius-md: 0.5rem;\n  --radius-lg: 0.75rem;\n  --radius-xl: 1rem;\n  --radius-2xl: 1.5rem;\n  \n  /* Shadows */\n  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  --shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  --shadow-2xl: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  \n  /* Transitions */\n  --transition-fast: 150ms ease-in-out;\n  --transition-base: 200ms ease-in-out;\n  --transition-slow: 300ms ease-in-out;\n  \n  /* Z-index */\n  --z-dropdown: 1000;\n  --z-sticky: 1020;\n  --z-fixed: 1030;\n  --z-modal-backdrop: 1040;\n  --z-modal: 1050;\n  --z-popover: 1060;\n  --z-tooltip: 1070;\n}\n\n/* Base Typography */\nbody {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-base);\n  line-height: var(--line-height-normal);\n  color: var(--gray-700);\n  background-color: var(--gray-50);\n}\n\nh1, h2, h3, h4, h5, h6 {\n  font-family: var(--font-family-heading);\n  font-weight: var(--font-weight-semibold);\n  line-height: var(--line-height-tight);\n  color: var(--primary-color);\n  margin: 0;\n}\n\nh1 { font-size: var(--font-size-3xl); }\nh2 { font-size: var(--font-size-2xl); }\nh3 { font-size: var(--font-size-xl); }\nh4 { font-size: var(--font-size-lg); }\nh5 { font-size: var(--font-size-base); }\nh6 { font-size: var(--font-size-sm); }\n\n/* Button Base Styles */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-sm);\n  padding: var(--space-sm) var(--space-lg);\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-medium);\n  line-height: var(--line-height-tight);\n  border: 1px solid transparent;\n  border-radius: var(--radius-md);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n.btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Button Variants */\n.btn-primary {\n  background-color: var(--primary-color);\n  color: var(--white);\n  border-color: var(--primary-color);\n}\n\n.btn-primary:hover:not(:disabled) {\n  background-color: var(--primary-light);\n  border-color: var(--primary-light);\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-lg);\n}\n\n.btn-secondary {\n  background-color: var(--white);\n  color: var(--secondary-color);\n  border-color: var(--gray-300);\n}\n\n.btn-secondary:hover:not(:disabled) {\n  background-color: var(--gray-50);\n  border-color: var(--gray-400);\n}\n\n.btn-success {\n  background-color: var(--success-color);\n  color: var(--white);\n  border-color: var(--success-color);\n}\n\n.btn-success:hover:not(:disabled) {\n  background-color: var(--success-light);\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-lg);\n}\n\n.btn-warning {\n  background-color: var(--warning-color);\n  color: var(--white);\n  border-color: var(--warning-color);\n}\n\n.btn-warning:hover:not(:disabled) {\n  background-color: var(--warning-light);\n  transform: translateY(-1px);\n}\n\n.btn-danger {\n  background-color: var(--error-color);\n  color: var(--white);\n  border-color: var(--error-color);\n}\n\n.btn-danger:hover:not(:disabled) {\n  background-color: var(--error-light);\n  transform: translateY(-1px);\n}\n\n/* Button Sizes */\n.btn-sm {\n  padding: calc(var(--space-sm) * 0.75) var(--space-md);\n  font-size: var(--font-size-xs);\n}\n\n.btn-lg {\n  padding: var(--space-md) var(--space-xl);\n  font-size: var(--font-size-base);\n}\n\n/* Card Components */\n.card {\n  background-color: var(--white);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-sm);\n  border: 1px solid var(--gray-200);\n  transition: all var(--transition-base);\n}\n\n.card:hover {\n  box-shadow: var(--shadow-md);\n  transform: translateY(-2px);\n}\n\n.card-header {\n  padding: var(--space-lg) var(--space-xl);\n  border-bottom: 1px solid var(--gray-200);\n}\n\n.card-body {\n  padding: var(--space-xl);\n}\n\n.card-footer {\n  padding: var(--space-lg) var(--space-xl);\n  border-top: 1px solid var(--gray-200);\n  background-color: var(--gray-50);\n  border-radius: 0 0 var(--radius-lg) var(--radius-lg);\n}\n\n/* Form Elements */\n.form-group {\n  margin-bottom: var(--space-lg);\n}\n\n.form-label {\n  display: block;\n  margin-bottom: var(--space-sm);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-medium);\n  color: var(--gray-700);\n}\n\n.form-input {\n  width: 100%;\n  padding: var(--space-md);\n  font-size: var(--font-size-sm);\n  line-height: var(--line-height-tight);\n  color: var(--gray-700);\n  background-color: var(--white);\n  border: 1px solid var(--gray-300);\n  border-radius: var(--radius-md);\n  transition: border-color var(--transition-fast), box-shadow var(--transition-fast);\n}\n\n.form-input:focus {\n  outline: none;\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.form-select {\n  width: 100%;\n  padding: var(--space-md);\n  font-size: var(--font-size-sm);\n  color: var(--gray-700);\n  background-color: var(--white);\n  border: 1px solid var(--gray-300);\n  border-radius: var(--radius-md);\n  transition: border-color var(--transition-fast);\n}\n\n/* Modal Base */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: var(--z-modal);\n  padding: var(--space-lg);\n}\n\n.modal-content {\n  background-color: var(--white);\n  border-radius: var(--radius-xl);\n  box-shadow: var(--shadow-2xl);\n  max-width: 90vw;\n  max-height: 90vh;\n  overflow: hidden;\n  animation: modalSlideIn 0.3s ease-out;\n}\n\n@keyframes modalSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-50px) scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.modal-header {\n  padding: var(--space-xl);\n  border-bottom: 1px solid var(--gray-200);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.modal-title {\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-semibold);\n  color: var(--primary-color);\n}\n\n.modal-close {\n  background: none;\n  border: none;\n  font-size: var(--font-size-xl);\n  color: var(--gray-400);\n  cursor: pointer;\n  padding: var(--space-sm);\n  border-radius: var(--radius-md);\n  transition: color var(--transition-fast);\n}\n\n.modal-close:hover {\n  color: var(--gray-600);\n}\n\n.modal-body {\n  padding: var(--space-xl);\n  overflow-y: auto;\n}\n\n.modal-footer {\n  padding: var(--space-xl);\n  border-top: 1px solid var(--gray-200);\n  display: flex;\n  gap: var(--space-md);\n  justify-content: flex-end;\n}\n\n/* Status Badges */\n.status-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: var(--space-xs) var(--space-sm);\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-medium);\n  border-radius: var(--radius-md);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.status-badge.success {\n  background-color: rgba(56, 161, 105, 0.1);\n  color: var(--success-color);\n}\n\n.status-badge.warning {\n  background-color: rgba(237, 137, 54, 0.1);\n  color: var(--warning-color);\n}\n\n.status-badge.danger {\n  background-color: rgba(229, 62, 62, 0.1);\n  color: var(--error-color);\n}\n\n.status-badge.info {\n  background-color: rgba(49, 130, 206, 0.1);\n  color: var(--primary-accent);\n}\n\n/* Loading States */\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid var(--gray-200);\n  border-top: 4px solid var(--primary-color);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin: 0 auto;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.loading-text {\n  text-align: center;\n  color: var(--gray-500);\n  margin-top: var(--space-md);\n}\n\n/* Responsive Utilities */\n@media (max-width: 768px) {\n  .modal-content {\n    margin: var(--space-md);\n    max-width: calc(100vw - 2rem);\n  }\n  \n  .modal-header,\n  .modal-body,\n  .modal-footer {\n    padding: var(--space-lg);\n  }\n  \n  .btn {\n    padding: var(--space-md) var(--space-lg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
